"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateNodeTypePicker = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const workflow_1 = require("@sierralabs/workflow");
const StyledMenuItemContent = styled_components_1.default.div `
  display: flex;
  align-items: center;
  .MuiListItemIcon-root {
    min-width: auto;
    margin-right: 16px;
  }
`;
const options = [
    {
        title: 'Normal State',
        type: workflow_1.StateNodeType.Atomic,
        icon: react_1.default.createElement(icons_1.AccountTree, null)
    },
    {
        title: 'Parallel State',
        type: workflow_1.StateNodeType.Parallel,
        icon: react_1.default.createElement(icons_1.ViewStream, null)
    },
    {
        title: 'Final State',
        type: workflow_1.StateNodeType.Final,
        icon: react_1.default.createElement(icons_1.RadioButtonChecked, null)
    }
];
function isStateNodeType(value) {
    return options.some(option => option.type === value);
}
const StateNodeTypePicker = props => {
    const { value, onChange } = props;
    return (react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, size: 'small', className: 'field', variant: 'outlined', label: 'State Type', value: value || '', onChange: event => {
            const { value } = event.target;
            if (value) {
                const type = !isStateNodeType(value) || value === workflow_1.StateNodeType.Atomic
                    ? workflow_1.StateNodeType.Auto
                    : value;
                onChange === null || onChange === void 0 ? void 0 : onChange(type);
            }
        } }, options.map(({ title, type, icon }) => (react_1.default.createElement(core_1.MenuItem, { key: type, value: type },
        react_1.default.createElement(StyledMenuItemContent, null,
            react_1.default.createElement(core_1.ListItemIcon, null, icon),
            react_1.default.createElement(core_1.ListItemText, { primary: title })))))));
};
exports.StateNodeTypePicker = StateNodeTypePicker;
exports.default = exports.StateNodeTypePicker;
//# sourceMappingURL=StateNodeTypePicker.js.map